import { call, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import api from '../../../api';
import Paths from '../../../constants/Paths';

export function* fetchBoardByCurrentPath() {
  const pathsMatch = yield select(selectors.selectPathsMatch);
  console.log('PathMatchs');
  console.log(pathsMatch);
  let board;
  let card;
  let boardUsers;
  let labels;
  let lists;
  let cards;
  let cardMemberships;
  let cardLabels;
  let attachments;
  let cardRelations;

  if (pathsMatch) {
    let boardId;
    if (pathsMatch.pattern.path === Paths.BOARDS) {
      boardId = pathsMatch.params.id;
    } else if (pathsMatch.pattern.path === Paths.CARDS) {
      ({
        item: card,
        item: { boardId },
      } = yield call(request, api.getCard, pathsMatch.params.id));
    }

    if (boardId) {
      ({
        item: board,
        included: {
          boardUsers,
          labels,
          lists,
          cards,
          cardMemberships,
          cardLabels,
          attachments,
          cardRelations,
        },
      } = yield call(request, api.getBoard, boardId, true));
    }
  }

  return {
    board,
    card,
    boardUsers,
    labels,
    lists,
    cards,
    cardMemberships,
    cardLabels,
    attachments,
    cardRelations,
  };
}

export default {
  fetchBoardByCurrentPath,
};
